import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import shallow from "zustand/shallow";

import { groupBy } from "base/utils";
import { useUserStore, useAccountStore } from "base/stores";

import { REACTIONS_LIST } from "../../common/utils/constant";
import { useCommentStore } from "../../common/store/comment.store";
import { ReactionComponent } from "./reaction.component";

const INITIAL_STATE = {
  reactions: [],
  reactionsGroupBy: {},
  lastName: [],
  currentReactionType: {
    image: "Like-outline",
    Name: "Like",
    color: "var(--primary-blue-500)"
  },
  isCurrentUserReacted: false
};

ReactionWrapper.propTypes = {
  medium: PropTypes.string,
  mediumId: PropTypes.string,
  teamId: PropTypes.string,
  instanceId: PropTypes.string,
  instanceType: PropTypes.string,
  entityId: PropTypes.string,
  entityType: PropTypes.string,
  creatorId: PropTypes.string,
  isComment: PropTypes.bool,
  roles: PropTypes.array,
  seenCount: PropTypes.number,
  isBookmarked: PropTypes.bool,
  updateBookmarkList: PropTypes.func
};

export function ReactionWrapper(props) {
  const {
    medium,
    mediumId,
    teamId,
    instanceType,
    instanceId,
    entityType,
    entityId,
    isComment,
    creatorId,
    seenCount,
    roles,
    isBookmarked,
    updateBookmarkList
  } = props;
  const { currentUser } = useUserStore.getState();
  const { reactions } = useCommentStore(
    (state) => ({
      reactions:
        state.postMapping[instanceId] && state.postMapping[instanceId].reactions
          ? state.postMapping[instanceId].reactions
          : []
    }),
    shallow
  );

  const [reactionState, setReactionState] = useState(INITIAL_STATE);
  const [showReactionModal, setShowReactionModal] = useState(false);

  const params = {
    teamId,
    medium,
    mediumId,
    instanceType,
    instanceId,
    entityType,
    entityId,
    accountId: useAccountStore.getState()._id
  };

  const { reactToPost } = useCommentStore.getState();

  useEffect(
    function formatReactionState() {
      setReactionStatus(reactions);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [reactions]
  );

  function setReactionStatus(reactions) {
    if (reactions && reactions.length === 0) {
      if (!reactionState.reactions.length) return;
      setReactionState(INITIAL_STATE);
    } else {
      let currentReactionType = {};
      let Name = [];
      let isCurrentUserReacted;
      reactions &&
        reactions.find((reactedUser) => {
          if (currentUser._id === reactedUser._id) {
            currentReactionType = {
              image: reactedUser.ReactionType,
              Name: reactedUser.ReactionType
            };
            return true;
          } else {
            currentReactionType = {
              image: "Like-outline",
              Name: "Like",
              color: "var(--primary-blue-500)"
            };
            return false;
          }
        });
      REACTIONS_LIST.forEach((reaction) => {
        if (reaction.reactionType === currentReactionType.Name) {
          currentReactionType.color = reaction.color;
        }
      });
      reactions &&
        reactions.slice(0, 4).forEach((element) => {
          Name.push(element.Name);
        });
      let isCurrentUser =
        reactions &&
        reactions.findIndex((user) => user._id === currentUser._id);
      if (isCurrentUser > -1) {
        isCurrentUserReacted = true;
        if (Name.length > 1) {
          Name.splice(isCurrentUser, 1);
        }
      }
      setReactionState({
        reactions: reactions,
        lastName: Name,
        currentReactionType,
        isCurrentUserReacted: isCurrentUserReacted,
        reactionsGroupBy: groupBy(reactions, "ReactionType")
      });
    }
  }

  return (
    <ReactionComponent
      postReaction={(type) =>
        reactToPost(
          params,
          type,
          reactionState.currentReactionType,
          reactionState.isCurrentUserReacted
        )
      }
      state={reactionState}
      roles={roles}
      medium={medium}
      mediumId={mediumId}
      teamId={teamId}
      instanceId={instanceId}
      instanceType={instanceType}
      setShowReactionModal={setShowReactionModal}
      showReactionModal={showReactionModal}
      isComment={isComment}
      seenCount={seenCount}
      creatorId={creatorId}
      isBookmarked={isBookmarked}
      updateBookmarkList={updateBookmarkList}
    />
  );
}
